/**
 * The app's door to the Stytch SDK.
 *
 * Both platform variants live in `@src/packages/api/useStytch`, so the split —
 * and `useIsAuthReady`, which depends on it — is stated once. This file used to
 * carry its own `.ts`/`.web.ts` pair with the same two implementations.
 */
export {
  useStytch,
  useStytchUser,
  useStytchSession,
  useIsAuthReady,
} from "@src/packages/api/useStytch";
